import { ConfirmationEditDialog, type ConfirmationEditDialogProps } from '@/components/dialogs';
import {
  useNomenclatureContextWindows,
  useNomenclatureStoreActions,
} from '@/components/nomenclature/useNomenclatureStore';

// ----------------------------------------------------------------------

export type NomenclatureConfirmationEditDialogProps = Pick<ConfirmationEditDialogProps, 'isLoading' | 'onClose'> & {
  onProceed: () => Promise<void>;
};

// ----------------------------------------------------------------------

export const NomenclatureConfirmationEditDialog = (props: NomenclatureConfirmationEditDialogProps) => {
  const { isLoading, onProceed, onClose } = props;

  const { isConfirmationEditDialogVisible } = useNomenclatureContextWindows();
  const { closeConfirmationEditDialog } = useNomenclatureStoreActions();

  const handleClose = () => {
    closeConfirmationEditDialog();
    onClose?.();
  };

  const handleProceed = async () => {
    await onProceed();
    closeConfirmationEditDialog();
  };

  return (
    <ConfirmationEditDialog
      open={isConfirmationEditDialogVisible}
      isLoading={isLoading}
      onClose={handleClose}
      onProceed={handleProceed}
    />
  );
};
